import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import {StyledEngineProvider, ThemeProvider} from '@mui/material/styles'
import {createGlobalStyle} from 'styled-components'
import {muiTheme} from './mui-theme'

// CSS Variables from design-system/variables.css
const GlobalCSSVariables = createGlobalStyle`
  :root {
    /* Primary Colors (Blue scale) */
    --primary-900: #014a6b;
    --primary-800: #0163a4;
    --primary-700: #0285c7;
    --primary-600: #0296dd;
    --primary-500: #03A9FC;
    --primary-400: #35bafd;
    --primary-300: #66cbfd;
    --primary-200: #98dcfe;
    --primary-100: #c9edfe;
    --primary-50: #e4f6ff;

    /* JS Blue (Main Brand Color) */
    --js-blue: #03A9FC;
    
    /* Label Color */
    --label-gray: #707070;

    /* Neutral Colors (Gray scale) */
    --neutral-900: #1a1a1a;
    --neutral-800: #2d2d2d;
    --neutral-700: #404040;
    --neutral-600: #525252;
    --neutral-500: #666666;
    --neutral-400: #999999;
    --neutral-300: #cccccc;
    --neutral-200: #e6e6e6;
    --neutral-100: #f2f2f2;
    --neutral-50: #f9f9f9;

    /* Status Colors */
    --status-success: #22c55e;
    --status-warning: #f59e0b;
    --status-error: #ef4444;
    --status-info: #3b82f6;

    /* Background Colors */
    --background-default: #ffffff;
    --background-paper: #ffffff;
    --background-secondary: #f9f9f9;

    /* Shadow Styles */
    --shadow-light: 0 1px 3px rgba(0, 0, 0, 0.1);
    --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.1);
    --shadow-strong: 0 8px 32px rgba(0, 0, 0, 0.12);

    /* Border Radius */
    --border-radius-sm: 4px;
    --border-radius-md: 8px;
    --border-radius-lg: 12px;
    --border-radius-xl: 16px;
  }
`

// Hoist this. Doesn't need to be re-created on each render.
const inputCssBaseline = <CssBaseline />

export function UiThemeProvider({children}: {children: React.ReactNode}) {
  return (
    <ThemeProvider theme={muiTheme}>
      <StyledEngineProvider injectFirst>
        <GlobalCSSVariables />
        {inputCssBaseline}
        {children}
      </StyledEngineProvider>
    </ThemeProvider>
  )
}
